<template lang="pug">
v-container
  v-snackbar(:value="hasError" color="error")
    div {{ errorMessage }}
  div.resend-email-container.full-frame
    div.container-item
      v-img(src="/static/img/ld-powered-lw-logo.svg" height="50" contain)
    div.container-item.extra-padding
      v-img(src="/static/img/open-email-logo.svg" height="100" contain)
    div.resend-email-container(v-if="emailResent && !isLoading")
      div.container-item.subtitle Email verification has been resent
      div.container-item
        p.mb-0 Check your inbox! We've sent another verification email.
        p.mb-0 If you don't recieve it, please check your spam folder.
    div.resend-email-container(v-else)
      div.container-item.subtitle Verify your email address
      div.container-item
        p.mb-0 We're so happy you signed up for LionDesk.
        p.mb-0 We've sent you a verification email.
        p.mb-0 In order to get started, please verify your email address.
      div.container-item 
        v-btn.primary.rounded-button(@click="resend()") Send verification email again
    div.container-item.extra-padding 
      p Make sure to check your spam folder. Sender is 
        a(href="mailto:support@liondesk.com") support@liondesk.com.
      p.mb-0 If you experience difficulties, please reach out to our support department at 
        a(href="mailto:support@liondesk.com") support@liondesk.com
        span  for assistance.


</template>
  
<script>

import { createNamespacedHelpers } from 'vuex';

const {
  mapState: mapEmailVerificationState,
  mapActions: mapEmailVerificationActions,
} = createNamespacedHelpers('emailVerification');

const {
  mapState: mapUserInformationState,
} = createNamespacedHelpers('userInformation');


export default {
  name: 'ResendVerificationEmail',
  created() {
    this.resetEmailResent();
  },
  computed: {
    ...mapUserInformationState(['user']),
    ...mapEmailVerificationState(['emailResent', 'isLoading', 'hasError', 'errorMessage'])
  },
  methods: {
    ...mapEmailVerificationActions(['resendEmail', 'resetEmailResent']),
    resend() {
      this.resendEmail({email: this.user.email})
    },
  }


};
</script>
  
<style lang="scss" scoped>
.full-frame {
  height: 100%;
}

.resend-email-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  width: 100%;

  .container-item {
    margin-bottom: 25px;
    width: 50%;
    max-width: 500px;
  }

  .subtitle {
    font-size: 32px;
    color: #235EA1;
  }

  .extra-padding {
    padding-top: 5%;
  }

  .rounded-button {
    text-transform: none;
    border-radius: 5px;
  }
}
</style>
